<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolPoSdrResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                                <template #left-header>
                                    <b-button
                                        :disabled="$store.state['sithMesStoolPoSdr'].checkedItems.length < 1"
                                        variant="outline-primary"
                                        size="sm"
                                        @click="dialogSolutionVisible = true">处理
                                    </b-button>
                                    <mini-button :disable="$_notChecked" :loading="downloadLoading"
                                                 @btnClick="$_downloadBomDrawing">
                                        <i class="fa-solid fa-file-zipper"></i>
                                        技术文件下载
                                    </mini-button>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
        <el-dialog title="处理" :visible.sync="dialogSolutionVisible">
            <el-form :inline="true">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="解决方式">
                            <el-select v-model="solution" placeholder="请选择" class="w-100">
                                <el-option v-for="item in solutionOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="描述">
                            <el-input
                                    v-model="comments"
                                    type="textarea"
                                    placeholder="请输入描述"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="请上传附件" style="align-content: center">
                            <multi-attachment class="w-100"
                                              @idsChanged="changeAttachmentIds"
                                              :attachment-ids="attachmentIds">
                            </multi-attachment>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSolutionVisible = false">取 消</el-button>
                <el-button type="primary" @click="handle">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
// Author Shi Wen Long
// Date 2022-02-10 14:49:06

import emCommonListMixin from "@/mixin/em/common/list";
import emCustomVuexMixin from "@/mixin/em/customVuex";
import emCommonApiMixin from "@/mixin/em/common/api";
import commonViewsUtil from "@/utils/commonViewsUtil";
import MiniButton from "@/components/common/buttons/MiniButton.vue";
import PageMaterialDownloadBomDrawingMixin from "@/views/sithMesII/pds/stuffs/page-material-download-bom-drawing-mixin";
import MultiAttachment from "@/components/echarts-part/stuff/MultiAttachment.vue";

export default {
    name: "sithMesStoolPoSdrListView",
    components: {MultiAttachment, MiniButton},
    mixins: [emCommonListMixin, emCustomVuexMixin, emCommonApiMixin, commonViewsUtil, PageMaterialDownloadBomDrawingMixin],
    data() {
        return {

            dialogSolutionVisible: false,
            solutionOptions: [
                {value: '0', label: '报废'},
                {value: '1', label: '修复'},
                {value: '2', label: '让步接收'}
            ],
            solution: '',
            comments: '',
            attachmentIds:''

        }
    },
    props: {
        //是否启用行编辑
        prop_inline: {
            type: String,
            default: "0"
        }
    },
    computed: {
        modelName() {
            return 'sithMesStoolPoSdr'
        },
        $_rowMaterialKey() {
            return 'materialCode';
        }
    },
    methods: {

        changeAttachmentIds(ids) {
            this.attachmentIds = ids;
        },
        handle() {

            this.dialogSolutionVisible = false;

            let ids = this.$store.state['sithMesStoolPoSdr'].checkedItems.join(',');

            let form = {
                'comments': this.comments,
                'ids': ids,
                'attachmentIds': this.attachmentIds,
                'solution': this.solution
            }

            let url = this.$store.state.sithMesStoolPoSdr.baseModuleUrl + "/sithMesStoolPoSdr/handle";
            this.$_emApiMixin_post(url, form).then(response => {
                commonViewsUtil.showSuccess(this, "操作成功！");
                this.$refs['emListFilter'].doQuery();
            });


        }
    },
    mounted() {
        this.$refs["emListFilter"].doQuery();
    }
};
</script>
